import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { PlayerProfileState } from '../interface/interface';

const initialState: PlayerProfileState = {
	avatar: [],
	playerStats: [],
	medals: [],
	collectedMedals: [],
	lastDepositMethod: null,
	lastDepositBankId: null,
	collapsedMarkets: {
		prematch: {},
		live: {},
		popular: {},
	},
};

const avatarReducer = (state = initialState, action: Action) => {
	switch (action.type) {
		case actionTypes.SET_AVATAR:
			return { ...state, avatar: action.payload };
		case actionTypes.PLAYER_STATS:
			return {
				...state,
				playerStats: action.payload,
			};
		case actionTypes.FETCH_MEDALS_SUCCESS:
			return {
				...state,
				collectedMedals: action.payload,
			};
		case actionTypes.LAST_DEPOSIT_METHOD:
			return {
				...state,
				lastDepositMethod: action.payload.lastDepositMethod,
				lastDepositBankId: action.payload.lastDepositBankId,
			};
		case actionTypes.SET_COLLAPSED_MARKET:
			return {
				...state,
				collapsedMarkets: action.payload,
			};
		default:
			return state;
	}
};

export default avatarReducer;
